module.exports = __webpack_public_path__ + "img/icon_wuwj.5e1b7ce4.png";